import React from 'react';
export function Header() {
  return <header className="bg-white py-6 px-8 flex items-center justify-between border-b border-gray-200" data-id="element-51">
      <div className="flex items-center" data-id="element-52">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/nXu4thkQbU79s983QADg4p/logoimagev2.png" alt="Justin for Us" className="h-20 w-auto" data-id="element-53" />
      </div>
      <div className="h-24 w-px bg-gray-300 mx-8" data-id="element-54" />
      <nav data-id="element-55">
        <a href="#meet" className="text-blue-700 text-xl font-semibold tracking-wide uppercase hover:text-blue-800 transition-colors" data-id="element-56">
          Meet Justin
        </a>
      </nav>
    </header>;
}